import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import * as paths from 'config/routes'
import { createTicketRBAC } from '../pages/CreateTicket/rbac'
import { myTicketsRBAC } from '../pages/MyTickets/rbac'
import { allTicketsRBAC } from '../pages/AllTickets/rbac'

const CreateTicket = lazy(() => import('../pages/CreateTicket'))
const MyTickets = lazy(() => import('../pages/MyTickets'))
const AllTickets = lazy(() => import('../pages/AllTickets'))

export const CreateTicketRoute: RouterFeatureInterface<
  'ticketingCreateRoute',
  typeof paths.ticketingCreate
> = {
  name: 'ticketingCreateRoute',
  Component: CreateTicket,
  path: paths.ticketingCreate,
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: createTicketRBAC.pageID,
}
export const MyTicketsRoute: RouterFeatureInterface<
  'ticketingMyTicketsRoute',
  typeof paths.ticketingMyTickets
> = {
  name: 'ticketingMyTicketsRoute',
  Component: MyTickets,
  path: paths.ticketingMyTickets,
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: myTicketsRBAC.pageID,
}

export const AllTicketsRoute: RouterFeatureInterface<
  'ticketingAllTicketsRoute',
  typeof paths.ticketingAllTickets
> = {
  name: 'ticketingAllTicketsRoute',
  Component: AllTickets,
  path: paths.ticketingAllTickets,
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: allTicketsRBAC.pageID,
}

const TicketingRouter = [CreateTicketRoute, MyTicketsRoute, AllTicketsRoute]

export const TicketingRouterDetail = generateRouterDetail(TicketingRouter)
export default TicketingRouter
